import { render } from "./App.vue?vue&type=template&id=4bce3ffa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4bce3ffa&lang=css"

import exportComponent from "/builds/downloadportal/external-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__